












































































import {Vue, Component} from 'vue-property-decorator';
import TuiTree from '@/components/mail/popup/Tuitree.vue';
import {popupResize} from '@/utils/ncp';
import {GetMailTemplatesCustomGroupsRequest} from 'supporter';
@Component({
  components: {
    TuiTree
  }
})
export default class TemplateList extends Vue {
  private theData: any[] = [];
  private selectNum: number = 1;
  private onceFlag: boolean = false;
  private selectForm = {
    usable: true,
    templateNo: '',
    displayOrder: '',
    name: '',
    title: '',
    content: '',
    parentData: {
      groupNo: 0
    }
  };
  private submitBtn() {
    const tree = (this.$refs.theTree as any).tree;
    const selectedNodeId = tree.getSelectedNodeId();
    const depth = tree.getDepth(selectedNodeId);

    if (depth === null) {
      alert(this.$t('MAIL_POP_TEMP_SELECT_TEMPLATE'));

      return;
    }

    if (depth === 1) {
      alert(this.$t('MAIL_POP_TEMP_SELECT_TEMPLATE'));
    } else {
      const mailTemplate = tree.getNodeData(selectedNodeId);
      $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback}(${JSON.stringify(mailTemplate)});`);
      window.close();
    }
  }
  private cancelBtn() {
    window.close();
  }
  private tuiTreeSelect(template: any): void {
    const tree = (this.$refs.theTree as any).tree;
    this.selectNum = template.theIndex;
    if (this.selectNum === 2) {
      if (this.selectForm.templateNo === template.theObj.templateNo) {
        return;
      }
      this.selectForm = template.theObj;
      this.selectForm.parentData = template.theParentData;
    } else if (this.onceFlag) {
      tree.open(template.originData.nodeId);
    }
    this.onceFlag = true;
  }
  private dataFormat(data: any[]): any[] {
    let newData = data.map(item => {
      Vue.set(item, 'text', item.name);
      if (item.templates) {
        Vue.set(item, 'children', item.templates);
        if (item.templates.length > 0) {
          this.dataFormat(item.children);
        }
      }
      return item;
    });
    return newData;
  }
  private initData(): void {
    let theObj: GetMailTemplatesCustomGroupsRequest = {
      params: {
        mallNo: Number(this.$route.query.mallNo),
        used: true
      }
    };
    this.$api.getMailTemplatesCustomGroups(theObj).then(res => {
      this.theData = [];
      this.theData = this.dataFormat(res.data);
    });
  }
  private mounted(): void {
    this.initData();
    this.$nextTick(() => {
      popupResize(1230, 613);
    });
  }
}
